<template>
  <li :class="indicatorclass">
    <div v-if="step.id == currentStep && step.action">
      <div class="step" @click="step.action"><i :class="step.icon_class"></i></div>
      <div class="caption">
          <span :class="{'btn-warning': step.warning}" class="btn btn-fill" @click="step.action" style="white-space: normal"><i class="fa fa-mouse-pointer"></i>{{step.title}}</span>
      </div>
    </div>
    <div v-else>
      <div class="step"><i :class="step.icon_class"></i></div>
      <div class="caption hidden-xs hidden-sm"><span v-text="step.title"></span></div>
    </div>
  </li>
</template>

<script>
  export default {
    name: "step-navigation-step",
    props: {
      step: Object,
      currentStep: Number
    },
    computed: {
      indicatorclass() {
        return {
            active: this.step.id == this.currentStep,
            complete: this.currentStep > this.step.id,
            warning: this.step.warning
        };
      }
    }
  }
</script>